import React from "react";
import "./ExportLoader.css";

const ExportLoader = ({ type = "pdf", open, message }) => {
    //message need if only we want to show custom message
    if (!open) return null;

    // Define color and label based on type
    const label = type === "pdf" ? "Exporting PDF..." : "Exporting Excel...";

    return (
        <div className="export-loader-overlay">
            <div className="export-loader-box">
                {/* Animated circular ring */}
                <svg className="loader-ring" viewBox="0 0 50 50">
                    <circle
                        className="loader-ring-bg"
                        cx="25"
                        cy="25"
                        r="20"
                        stroke="#eee"
                        strokeWidth="4"
                        fill="none"
                    />
                </svg>

                {/* Label text */}
                <div className="export-loader-text">{label}</div>
            </div>
        </div>
    );
};

export default ExportLoader;
